<template>
    <div class="chart">
        <vue-apex-charts
            :type="chartType"
            :series="series"
            :options="chartOptions"
        />
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment/moment';

export default {
    name: 'dashboard',
    components: {
        VueApexCharts,
    },
    props: [ 'data', 'type', 'dataType' ],
    data() {
        return {
            series: null,
            options: {
                fill: null,
                plotOptions: null,
                height: '100%',
                dataLabels: null,
                xaxis: null,
                yaxis: null,
                tooltip: null,
            },
            data_value_format: {minimumFractionDigits: 2, maximumFractionDigits: 2}
        };
    },
    created() {
        Object.keys(this.data).map((key) => {
            this.series = this.getBookingStatisticsData();

            if(this.chartType === 'bar') {
                this.options.plotOptions = {
                    bar: {
                        // horizontal: true,
                        // barHeight: '100%',
                    }
                };

                this.options.dataLabels = {
                    enabled: false
                };

                this.options.fill = {
                    colors: ['#009bba']
                };

                if(this.isNumberChart()) {
                    this.options.xaxis = {
                        // min: 0,
                        // max: 100,
                        categories: this.getCategories(),
                        // labels: {
                        //     formatter(val) {
                        //         return Math.abs(Math.round(parseInt(val, 10))) + '%';
                        //     }
                        // },
                        title: {
                            text: this.$t(`dashboard.bookingStatLabels.${this.type}`),
                            offsetY: 90,
                        },
                    };
                    /* todo:gk hack ... bessere Lösung vorhanden? */
                    const myData = this.data;
                    const myThis = this;
                    this.options.tooltip = {
                        x: {
                            // formatter: (val) => {
                            //     return this.$t('generic.time', { time: val });
                            // }
                            formatter: this.getTooltipText,
                        },
                        y: {
                            formatter(val, { series, seriesIndex, dataPointIndex, w }) {
                                let realVal = Object.values(myData)[dataPointIndex];
                                let result = '';
                                if(myThis.dataType === 'C') {
                                    result = realVal + ' ' + myThis.$t('chart.bookings') + ', ';
                                    return result + Math.abs(Math.round(parseFloat(val) * 100) / 100) + myThis.$t('chart.of_all_bookings');
                                } else {
                                    result = realVal.toLocaleString(myThis.$t('chart.number_format'), myThis.data_value_format) + ' ' + myThis.$t('chart.sales_volume') + ', ';
                                    return result + Math.abs(Math.round(parseFloat(val) * 100) / 100) + myThis.$t('chart.of_all_bookings');
                                }
                            }
                        }
                    };
                }

                this.options.yaxis = {
                    min: 0,
                    max: 100,
                    decimalsInFloat: this.getYAxisDecimals(),
                    title: {
                        text: this.$t('dashboard.bookingStatLabels.yAxis'),
                    },
                };
            } else {
                const myThis = this;
                const data = Object.values(this.data);
                const sum = data.reduce((a, b) => a + b, 0);

                this.options = {
                    labels: this.getBookingStatisticsLabels(this.data),
                };

                this.options.tooltip = {
                    y: {
                        formatter(val) {
                            let result = '';
                            if(myThis.dataType === 'C') {
                                result = val + ' ' + myThis.$t('chart.bookings') + ', ';
                                const value = (parseInt(val) * 100) / sum;
                                return result + Math.abs(Math.round(value * 100) / 100) + myThis.$t('chart.of_all_bookings');
                            } else {
                                result = val.toLocaleString(myThis.$t('chart.number_format'), myThis.data_value_format) + ' ' + myThis.$t('chart.sales_volume') + ', ';
                                const value = (parseInt(val) * 100) / sum;
                                return result + Math.abs(Math.round(value * 100) / 100) + myThis.$t('chart.of_all_bookings');
                            }
                        }
                    }
                };
            }
        });
    },
    computed: {
        chartOptions() {
            return Object.keys(this.options)
                .filter((key) => this.options[key])
                .reduce((o, key) => ({...o, [key]: this.options[key]}), {});
        },
        chartType() {
            if(this.isNumberChart()) {
                return 'bar';
            }

            return 'donut';
        },
    },
    methods: {
        getBookingStatisticsData() {
            const data = Object.values(this.data);
            const sum = data.reduce((a, b) => a + b, 0);

            if(this.chartType === 'donut') {
                return data;
            }

            if(this.isNumberChart()) {
                return [{
                    name: this.$t('bookings.bookings.bookings'),
                    data: data.map((d) => (d * 100) / sum),
                }];
            }

            return [{
                name: this.$t('bookings.bookings.bookings'),
                data,
            }];
        },

        getYAxisDecimals() {
            if(this.dataType === 'C') { return 0; }
            return 2;
        },

        getBookingStatisticsLabels(labels) {
            if(this.type === 'acco_maintype') {
                return Object.keys(labels).map((label) => this.$t(`generic.campsite_types.${label}.name`));
            } else if(this.type === 'booking_day') {
                return Object.keys(labels).map((label) => this.$t(`generic.calendar.weeknames.map.${label}`));
            } else if(this.type === 'year_month_arrival') {
                return Object.keys(labels).map((label) => moment(label).format('MMM yyyy'));
            }

            return Object.keys(labels);
        },

        isNumberChart() {
            const charts = [
                'booking_hour',
                'person_count',
                'durations',
                'year_month_arrival',
            ];

            return charts.includes(this.type);
        },

        getTooltipText(val) {
            if(this.type === 'booking_hour') {
                return this.$t('generic.time', { time: val });
            } else if(this.type === 'person_count') {
                return this.$tc('generic.person', parseInt(val), { n: parseInt(val) });
            } else if(this.type === 'durations') {
                return this.$tc('generic.day', parseInt(val), { n: parseInt(val) });
            }

            return val;
        },

        getCategories() {
            if(this.type === 'year_month_arrival') {
                return Object.keys(this.data).map((val) => {
                    const date = val.split('-');

                    return `${date[1]}/${date[0]}`;
                });
            }
            return Object.keys(this.data);
        }
    },
};
</script>

<style lang="scss" scoped>
.chart {
    position: relative;
    display: block;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/components/chart/chart.vue